import { Flex } from '@chakra-ui/react';
import { rem } from 'polished';
import { ReactNode } from 'react';

type ReviewCardBoxProps = {
  children: ReactNode;
  variant?: 'filled' | 'transparent';
};

export const ReviewCardBox = ({ children, variant = 'filled' }: ReviewCardBoxProps) => {
  return (
    <Flex
      px="space.24"
      py="space.32"
      flexDirection="column"
      background={variant === 'filled' ? 'rgba(216, 216, 216, 0.08)' : 'transparent'}
      borderRadius={rem(4)}
      border={
        variant === 'filled'
          ? '1px solid rgba(105, 120, 255, 0.09)'
          : '1px solid rgba(216, 216, 216, 0.12)'
      }
      gap="space.24"
      position="relative"
      w="100%">
      {children}
    </Flex>
  );
};
